import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import AdminLayout from "../../layouts/AdminLayout/AdminLayout";
import DashboardAdmin from "../../components/Admin/DashboardAdmin/DashboardAdmin";
import CategoryAdmin from "../../components/Admin/CategoryAdmin/CategoryAdmin";
import CategoryAdminContext from "../../context/Admin/CategoryAdminContext/CategoryAdminContext";
import MenuAdminContext from "../../context/Admin/MenuAdminContext/MenuAdminContext";
import MenuAdmin from "../../components/Admin/MenuAdmin/MenuAdmin";
import UserAdminContext from "../../context/Admin/UserAdminContext/UserAdminContext";
import ImageAdminContext from "../../context/Admin/ImageAdminContext/ImageAdminContext";
import ImageAdmin from "../../components/Admin/ImageAdmin/ImageAdmin";
import SettingAdminContext from "../../context/Admin/SettingAdminContext/SettingAdminContext";
import SettingAdmin from "../../components/Admin/SettingAdmin/SettingAdmin";
import UserAdmin from "../../components/Admin/UserAdmin/UserAdmin";
import NotFoundPage from "../../components/Page/NotFoundPage/NotFoundPage";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems } from "../../utils/enum";

const AdminContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[0])
    return <Navigate to="/" replace />;

  return (
    <AdminLayout>
      <Routes>
        {/* Dashboard */}
        <Route index element={<DashboardAdmin />} />
        {/* Category */}
        <Route
          path="/category"
          element={
            <CategoryAdminContext>
              <CategoryAdmin />
            </CategoryAdminContext>
          }
        />
        {/* Menu */}
        <Route
          path="/menu"
          element={
            <MenuAdminContext>
              <MenuAdmin />
            </MenuAdminContext>
          }
        />
        {/* User */}
        <Route
          path="/user"
          element={
            <UserAdminContext>
              <UserAdmin />
            </UserAdminContext>
          }
        />
        {/* Image */}
        <Route
          path="/image"
          element={
            <ImageAdminContext>
              <ImageAdmin />
            </ImageAdminContext>
          }
        />
        {/* Setting */}
        <Route
          path="/setting"
          element={
            <SettingAdminContext>
              <SettingAdmin />
            </SettingAdminContext>
          }
        />
        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminContainer;
